import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (!container.hasChildNodes()) {
  ReactDOM.createRoot(container).render(app); // dev server (no prerendered snapshot)
} else {
  // A production build ships #root already filled in (scripts/prerender.js). Let the browser
  // paint that first — on a fast connection it would otherwise run this bundle before the
  // first paint — then let React adopt the existing DOM (hydration) instead of rebuilding it.
  requestAnimationFrame(() => setTimeout(() => ReactDOM.hydrateRoot(container, app), 0));
}
